<template>
  <div class="card">
    <div
      class="d-flex justify-end align-center mb-1"
      v-for="element in itemsText"
      :key="element.value"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span
            v-bind="attrs"
            v-on="on"
            class="a-text description"
            :style="{
              color: $vuetify.theme.themes.light[color[element.color]] + 'BB',
            }"
            >{{ item[element.value] }}</span
          >
        </template>
        <span>{{ item[element.value] }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      itemsText: [
        { value: "timestamp", color: 3 },
        { value: "area", color: "" },
        {
          value: "name",
          color: this.item.state,
        },
        { value: "description", color: "" },
        { value: "detailedState", color: "" },
      ],
      color: ["error", "warning", "accent", "gray"],
    };
  },
};
</script>

<style scoped lang="scss">
.card {
  background: $light;
  padding: 10px;
  border-radius: 4px;
  width: 175px;
}
.description {
  width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: end;
}
</style>